import axios from 'axios';
import React, { FC, useState, useEffect } from 'react';
import { Talkr } from 'talkr';
import { LANGUAGES } from 'types';

interface Props {
	children: React.ReactNode;
}

export const Localisations: FC<Props> = props => {
	const { children } = props;
	const [languages, setLanguages] = useState({});
	const [index, setIndex] = useState<number>();

	useEffect(() => {
		const browserLanguage = navigator.language.split('-')[0];
		const language: LANGUAGES = browserLanguage as LANGUAGES;

		if (browserLanguage === 'en' || !Object.values(LANGUAGES).includes(language)) {
			setIndex(1);
		} else {
			setIndex(2);
		}

		Object.entries(LANGUAGES).map(async ([_, value]) => {
			const publicURL = process.env.PUBLIC_URL ?? '/';

			if (value === browserLanguage || value === 'en') {
				const data = await axios
					.get(`${window.location.origin}${publicURL}/locales/${value}.json`)
					.then(response => {
						return { [value]: response.data };
					});
				setLanguages(prev => ({ ...prev, ...data }));
			}
		});
	}, []);

	return (
		<>
			{Object.entries(languages).length === index && (
				<Talkr languages={languages} defaultLanguage={LANGUAGES.EN} detectBrowserLanguage>
					{children}
				</Talkr>
			)}
		</>
	);
};
